import { DEVICES_LOADED, LOAD_DEVICE_REQ, LOAD_DEVICE_FINISH, LOAD_DEVICE_ERROR } from "../config/actionType";


const initialState = {
    loading: false,
    devices: [],
    error: ""
};

export const deviceReducer = (state = initialState, action) => {
    switch (action.type)
    {
        case DEVICES_LOADED:
            return (
                {
                    ...state,
                   devices: action.devices,
                }
            )
            case LOAD_DEVICE_REQ:
            return (
                {
                   ...state,
                   loading: true,
                   error: ""
                }
            )
            case LOAD_DEVICE_ERROR:
                return (
                    {
                       ...state,
                       error: "Erreur requete"
                    }
                )
                case LOAD_DEVICE_FINISH:
                return (
                    {
                       ...state,
                       loading: false,
                    }
                )

        default:
            return state
    }
}
